import React, { Component } from 'react';
import ContentPanel from '../../components/ContentPanel/ContentPanel';
import Skeleton from '../../components/Skeleton/Skeleton';
import CardsList from "../../components/CardsList/CardsList";
import {REQUEST_PRESS_RELEASES_DATA} from "../../actions/pressReleasesActions";
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import store from "../../store";
import {Helmet} from "react-helmet";

const mapStateToProps = state => {
  return {
    pressReleasesData: state.pressReleasesData
  }
};

const mapDispatchToProps = dispatch => ({
  getPressReleasesData: () => dispatch({type: REQUEST_PRESS_RELEASES_DATA})
});

class PressReleases extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.pressReleasesData).length) {
      this.props.getPressReleasesData();
    }
  };

  render() {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "About" ? row.sections.map((section) => {
                          return section.title === "Press Releases" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL" />}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR" />}
          templateUrl="./content/about/page-components/text-block/press-releases-heading.html"
        />
        <CardsList
          layoutData={Object.keys(this.props.pressReleasesData).length ? this.props.pressReleasesData.pressReleases : null}
          pathForItem="/about/press-releases/press-release"
          hasViewSwitcher={true}
          hasCardsView={false}
          showDatesOfIndividualContent={true}
        />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PressReleases));



// WEBPACK FOOTER //
// ./src/pages/About/PressReleases.js